export const markerSpec = {
  inline: true,
  group: 'inline',
  selectable: false,
  attrs: {
    id: {
      default: ''
    },
    class: {
      default: 'embercom-prosemirror-composer-marker'
    }
  },
  toDOM(node) {
    return ['span', {
      id: node.attrs.id,
      class: node.attrs.class
    }];
  }
};